import { SettingsCard } from "@/containers/game/settings/styled-components";
import { BybSlider } from "@Components/common/byb-ds";
import SettingsPage from "@Components/game/settings/settings-page";
import Section from "@Containers/shared/cards/section";
import { AnalyticsEvents, Preferences } from "@Enums/index";
import { useAnalytics } from "@hooks/common/analytics/use-analytics";
import useGameSettings from "@hooks/common/settings/use-game-settings";
import useI18n from "@i18n";
import { Stack } from "@mui/material";

const audioDefaults = {
  [Preferences.volume_master]: 50,
  [Preferences.volume_music]: 50,
  [Preferences.volume_voice]: 50,
  [Preferences.volume_crowd]: 50,
};

const audioFields = [
  { id: Preferences.volume_master, label: "settings.audio.master" },
  { id: Preferences.volume_music, label: "settings.audio.music" },
  { id: Preferences.volume_voice, label: "settings.audio.voice" },
  { id: Preferences.volume_crowd, label: "settings.audio.crowd" },
] as const;

const AudioSettings = () => {
  const { i18n } = useI18n();
  const { track } = useAnalytics();
  const { values, setValue, ready, error, refetch } = useGameSettings(audioDefaults, {
    onApply: values =>
      track(AnalyticsEvents.volume_adjusted, {
        volumeMaster: values[Preferences.volume_master],
        volumeMusic: values[Preferences.volume_music],
        volumeVoice: values[Preferences.volume_voice],
        volumeCrowd: values[Preferences.volume_crowd],
      }),
  });

  return (
    <SettingsPage id="SETTINGS-AUDIO" title={i18n("settings.audio.title")} ready={ready} error={error} refetch={refetch}>
      <Section title={i18n("settings.audio.section")}>
        <Stack spacing={1.5}>
          {audioFields.map(({ id, label }) => (
            <SettingsCard key={id}>
              <BybSlider label={i18n(label)} value={values[id]} onChange={value => setValue(id, value)} />
            </SettingsCard>
          ))}
        </Stack>
      </Section>
    </SettingsPage>
  );
};

export default AudioSettings;
